
export const TIME_SLOTS = [
  { label: "07:00 - 09:00", start: "07:00", end: "09:00" },
  { label: "09:00 - 11:00", start: "09:00", end: "11:00" },
  { label: "13:30 - 15:30", start: "13:30", end: "15:30" },
] as const;

export type UserRole = "admin" | "doctor" | "nurse" | "department_head";

// Specialty/Department types
export interface Specialty {
  id: string;
  name: string;
  nameVi: string;
}

// Doctor type
export interface Doctor {
  id: string;
  name: string;
  specialtyId: string;
  departmentId: string;
  avatar?: string;
}

// Department type
export interface Department {
  id: string;
  name: string;
  nameVi: string;
  headDoctorId?: string;
}

// Patient type
export interface Patient {
  id: string;
  name: string;
  phone: string;
  dateOfBirth: string;
  gender: "male" | "female";
  insuranceNumber?: string;
}

// Appointment status
export type AppointmentStatus = "scheduled" | "confirmed" | "completed" | "cancelled";

// Appointment type
export interface Appointment {
  id: string;
  patientId: string;
  patientName: string;
  doctorId: string;
  doctorName: string;
  specialtyId: string;
  specialtyName: string;
  departmentId: string;
  departmentName: string;
  date: string;
  time: string;
  room: string;
  status: AppointmentStatus;
  notes?: string;
}

// KPI statistics
export interface DashboardStats {
  todayAppointments: number;
  weekAppointments: number;
  activeDoctors: number;
  newPatients: number;
  avgPerDoctor?: number;
  pendingCheckIns?: number;
  completedThisWeek?: number;
  upcomingToday?: number;
}

// Chart data types
export interface DailyTrendData {
  day: string;
  dayShort: string;
  appointments: number;
  isToday: boolean;
}

export interface SpecialtyChartData {
  specialtyId: string;
  specialtyName: string;
  appointments: number;
  percentage: number;
}

export interface DoctorWorkloadData {
  doctorId: string;
  doctorName: string;
  specialty: string;
  appointments: number;
}

// Filter options
export interface FilterOptions {
  dateRange: "today" | "week";
  departmentId?: string;
  doctorId?: string;
  specialtyId?: string;
  searchQuery?: string;
}

